import { render, staticRenderFns } from "./Mermas.vue?vue&type=template&id=03661abe&scoped=true&"
import script from "./Mermas.vue?vue&type=script&lang=js&"
export * from "./Mermas.vue?vue&type=script&lang=js&"
import style0 from "./Mermas.vue?vue&type=style&index=0&id=03661abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03661abe",
  null
  
)

export default component.exports